import React from 'react';
import { Layout, Spin, Icon } from 'antd';
import { connect } from 'react-redux';
import LocaleReceiver from 'antd/lib/locale-provider/LocaleReceiver';

import HistoryModal from '../routes/down';
import GlobalHeader from './GlobalHeader/GlobalHeader';
import SiderMenu from './SiderMenu/SiderMenu';
import styles from './layouts.less';
import { baseRoutePath } from '../routes/router';

const { Content } = Layout;
const paths = ['', 'good/good-import', 'relative-import', 'good/import-purchase'];

class BasicLayout extends React.Component {
  render() {
    const {
      children,
      cacheMenus,
      persistMenus,
      loading,
      location: { pathname },
      fromNp = false,
    } = this.props;

    return (
      <>
        <LocaleReceiver componentName="Sider">
          {(locale) => (
            <Spin spinning={loading} indicator={<Icon type="loading" />} size="large">
              <Layout className={styles.layout}>
                {fromNp ? <div></div> :
                  <SiderMenu locale={locale} onMenuItemClick={this.onMenuItemClick} {...this.props} />}
                <Layout>
                  {fromNp ? <div></div> : <GlobalHeader
                    locales={locale}
                    cacheMenus={cacheMenus}
                    persistMenus={persistMenus}
                    onAffixMenu={this.handleAffixMenu}
                    onUnAffixMenu={this.handleUnAffixMenu}
                    onRemovedMenu={this.handleRemovedHeaderMenu}
                  />}
                  <Content className={styles.layoutContent}>
                    <div
                      className={styles.content}
                      style={{ marginBottom: paths.includes(pathname.slice(4)) ? 15 : 50 }}
                    >
                      {children}
                    </div>
                  </Content>
                </Layout>
              </Layout>
            </Spin>
          )}
        </LocaleReceiver>
        {/* 导入导出 */}
        <LocaleReceiver componentName="ImportExport">
          {(locale) => <HistoryModal locales={locale} />}
        </LocaleReceiver>
      </>
    );
  }

  handleRemovedHeaderMenu = (menu) => {
    let path = baseRoutePath;
    const {
      location: { pathname },
      history,
      dispatch,
      cacheMenus,
      persistMenus,
    } = this.props;
    if (menu.path === pathname) {
      const menus = [...persistMenus, ...cacheMenus];
      const now = menus.reduce((tmp, v, index) => (v.path === menu.path ? index : tmp), 0);
      if (!now && menus.length > 1) {
        path = menus[now + 1].path;
      } else if (!!now) {
        path = menus[now - 1].path;
      }
      path !== pathname && history.push(path);
    }
    dispatch({ type: 'app/removedMenu', payload: { menu } });
  };
  handleUnAffixMenu = (menu) => {
    this.props.dispatch({ type: 'app/unAffixMenu', payload: { menu } });
  };

  handleAffixMenu = (menu) => {
    this.props.dispatch({ type: 'app/affixMenu', payload: { menu } });
  };
  onMenuItemClick = (menu) => {
    this.props.dispatch({ type: 'app/addCacheMenus', payload: { menu } });
  };
}

export default connect(({ appState }) => ({
  cacheMenus: appState.cacheMenus,
  persistMenus: appState.persistMenus,
  loading: appState.loading,
}))(BasicLayout);
